export type ColorTheme = "light" | "dark";

export function allColorThemes(): ColorTheme[] {
  return ["light", "dark"];
}

const LOCAL_STORAGE_COLOR_THEME_KEY = "hexgrip_color_theme";

const DEFAULT_COLOR_THEME: ColorTheme = "light";

export function loadColorTheme(): ColorTheme {
  const theme = localStorage.getItem(LOCAL_STORAGE_COLOR_THEME_KEY);

  if (theme === null) {
    return DEFAULT_COLOR_THEME;
  }

  if (theme === "light") {
    return "light";
  } else if (theme === "dark") {
    return "dark";
  } else {
    return DEFAULT_COLOR_THEME;
  }
}

export function saveColorTheme(colorTheme: ColorTheme): void {
  localStorage.setItem(LOCAL_STORAGE_COLOR_THEME_KEY, colorTheme);
}
